module.exports = __webpack_public_path__ + "img/9791188140367.d26cfc13.jpg";